import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { SearchStatus } from '../../../constants';
import getPriceBreakdownKey from '../../../helpers/getPriceBreakdownKey';
import {
  priceRequest,
  priceSuccess,
  priceFailure,
  priceBreakdowns,
  setPricingRequestStatus,
  priceRequestTakeLatest,
} from '../../slices/cruise';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* priceWorker(action) {
  try {
    const { city } = yield select((store) => store.tripSearch.searchObj.cruise.filters);
    const request = {
      ...action.payload,
      passengerCityCode: city ? city.value : null,
    };
    const breakdowns = yield select(priceBreakdowns);
    const key = getPriceBreakdownKey({
      ...action.payload,
    });
    if (!breakdowns[key]) {
      if (action.payload && !action.payload.hideSpinner) {
        yield put(setPricingRequestStatus(SearchStatus.SEARCHING));
      }
      const config = {
        method: 'post',
        url: `cruises/getCheapestTotalPrice?${queryString.stringify({
          itineraryId: request.itineraryId,
          passengerCityCode: request.passengerCityCode,
          cruiseLineId: request.cruiseLineId,
          isCruiseTour: request.isCruiseTour,
          resultno: request.resultno,
          gradeno: request.gradeno,
          farecode: request.farecode,
          sessionKey: request.sessionKey,
        })}`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: JSON.stringify([...request.searchInputs]),
      };

      const response = yield call(axios, config);

      yield put(priceSuccess({ [key]: response.data }));
      yield put(setPricingRequestStatus(SearchStatus.DONE));
    } else {
      yield put(priceSuccess({ [key]: breakdowns[key] }));
    }
  } catch (error) {
    console.error(error);
    yield put(setPricingRequestStatus(SearchStatus.DONE));
    yield put(priceFailure(error));
  }
}

function* priceWatcher() {
  yield takeEvery(priceRequest.toString(), priceWorker);
  yield takeLatest(priceRequestTakeLatest.toString(), priceWorker);
}

export default priceWatcher;
